import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import { ContextData } from '../../../../../../../context/Context';
import baseUrl from '../../../../../../../BaseURL'; 
import UploadForm from './UploadForm';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import axios from 'axios';
import GetPersonData from '../../../../../../../context/GetPersonData';
import Loader from '../../../../../../../routes/Loader';


export default function ScholarshipTable() {

  const { UserTokens, AdministratorTokens } = React.useContext(ContextData);
  const [PersonData, setPersonData] = React.useState(null);
  const [ScholarshipList, setScholarshipList] = React.useState([]);
  const [FilteredScholarshipList, setFilteredScholarshipList] = React.useState([]);
  const [OpenLoader, setOpenLoader] = React.useState(false); 

  React.useEffect(() => {
    setOpenLoader(true);
    GetPersonData(UserTokens, AdministratorTokens).then((data) => {
      if (data !== null) {
        setPersonData(data);
      }
      setOpenLoader(false);
    });
  }, []);

  React.useEffect(() => {
    async function FetchData() {
      setOpenLoader(true);
      try {
        const response = await axios.get(`${baseUrl}/auth/get_scholarship_list_applicant`, {
          withCredentials: true,
          headers: {
            'Accept': 'application/json',
            'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
          }
        });

        setScholarshipList(response.data);
      } catch (err) {
        if (err) console.log(err.message);
      }
      setOpenLoader(false);
    }
    FetchData();
  },[AdministratorTokens]);

  React.useEffect(() => {
    if (PersonData && ScholarshipList.length > 0) {
      const filteredList = ScholarshipList.filter(item => 
        item.qualification_type.toLowerCase() === PersonData.edu_data[0].applying_for_type.toLowerCase() && 
        (item.resdential_type === PersonData.bio_data[0].resdential_type || item.resdential_type === "both")
      );
      setFilteredScholarshipList(filteredList);
    }
  }, [PersonData, ScholarshipList]);

  return (
    <div className=''>
      <TableContainer component={Paper}>
        {OpenLoader && <Loader OpenLoader={OpenLoader} />}
        <Table sx={{ minWidth: 650, borderRadius: "7px" }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ background: "rgb(0, 24, 69)" }}>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>
                Scholarship Name<CloudDoneIcon sx={{ fontSize: "2em", marginLeft: "3px" }} />
              </TableCell>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>
                Scholarship Type<CloudDoneIcon sx={{ fontSize: "2em", marginLeft: "3px" }} />
              </TableCell>
              <TableCell align='center' sx={{ color: "white", fontWeight: "800", fontSize: "0.8em" }}>
                Enroll<RssFeedIcon sx={{ fontSize: "2em", marginLeft: "2px" }} />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              FilteredScholarshipList.map((list, index) => (
                <UploadForm
                  data={list}
                  key={index}
                  user_token = {UserTokens}
                  setOpenLoader={setOpenLoader}
                />
              ))
            }
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
